import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BASE_URL, BaseApi } from '@edl-development/edl-common';
import { EDLAutomationRuleActions } from '../enums/automation-rule/edl-automation-rule-actions.enum';


@Injectable()
export class AutoAssignmentApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getAllAutoAssignmentRules() {
        return this.http.get<any[]>(this.baseUri + '/automationRule/all');
    }

    getPermissions = () => {
        return this.http.get<EDLAutomationRuleActions[]>(`${this.baseUri}/automationRule/GetPermissions`);
    }

    addAutoAssignmentRule() {
        return this.http.post<any>(this.baseUri + '/automationRule', {});
    }

    addDefaultAutoAssignmentRules() {
        return this.http.post<any[]>(this.baseUri + '/automationRule/default', {});
    }

    updateAutoAssignmentRule(autoAssignmentRule: any) {
        return this.http.put<any>(this.baseUri + '/automationRule', autoAssignmentRule);
    }
}